import { render, staticRenderFns } from "./Patio.vue?vue&type=template&id=2217f945"
import script from "./Patio.vue?vue&type=script&lang=js"
export * from "./Patio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports